import { Component } from '@angular/core';

@Component({
  selector: 'icon-volume-on',
  standalone: true,
  template: `
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 24.75V22.7C19.5 22.2667 20.7083 21.4333 21.625 20.2C22.5417 18.9667 23 17.5667 23 16C23 14.4333 22.5417 13.0333 21.625 11.8C20.7083 10.5667 19.5 9.73333 18 9.3V7.25C20.0667 7.71667 21.75 8.7625 23.05 10.3875C24.35 12.0125 25 13.8833 25 16C25 18.1167 24.35 19.9875 23.05 21.6125C21.75 23.2375 20.0667 24.2833 18 24.75ZM7 19.025V13.025H11L16 8.025V24.025L11 19.025H7ZM18 20.025V11.975C18.7833 12.3417 19.3958 12.8917 19.8375 13.625C20.2792 14.3583 20.5 15.1583 20.5 16.025C20.5 16.875 20.2792 17.6625 19.8375 18.3875C19.3958 19.1125 18.7833 19.6583 18 20.025ZM14 12.875L11.85 15.025H9V17.025H11.85L14 19.175V12.875Z" fill="#1C6E70"/>
    </svg>
  `,
  styles: [
   `
    svg {
        path {
          fill: var(--main-color);
        }
      }

      svg:hover {
        path {
          fill: var(--main-color-strong);
        }
      }
    `
  ]
})

export class VolumeOnIconComponent {

}
